module.exports = __webpack_public_path__ + "img/t1-teal.a5dad5cd.png";